import { KeyTake } from "@pdfking/tfunc"

import { is_null } from "./is_null"
import { to_array } from "./to_array"

/**
 * Picks specified keys from object.
 *
 * @param data - Object to filter
 * @param to_take - Key(s) to keep (string, array, or null)
 * @returns Object with only specified keys
 *
 * @example
 * ```ts
 * import { key_take } from "@pdfking/rfunc"
 *
 * key_take({ a: "b", c: "d", e: "f" }, "a") // { a: "b" }
 * key_take({ a: "b", c: "d", e: "f" }, ["a", "c"]) // { a: "b", c: "d" }
 * key_take({ a: "b" }, null) // { a: "b" }
 * ```
 */
export const key_take = (data, to_take) => {
  if (is_null(to_take)) return data
  return KeyTake(data, to_array(to_take))
}
